module.exports = __webpack_public_path__ + "img/P150T_weapon_141.db1141cc.png";